import { logger } from 'logging-utils';
import { openSnackbar } from '../../snackbar/actions/snackbar-actions';
import {
  resetFields,
  setChannels,
  setLoadingSlackChannels,
  setLoadingSubmit,
} from '../store-actions/slack-store-actions';
import slackService from '../services';
import { GetSlackChannelsListInput } from '../types/slack-types';
import { isNull } from 'lodash';
import { snapshot } from 'valtio';
import SlackStore from '../store/slack-store';

export const getPublicChannels = async (input: GetSlackChannelsListInput) => {
  try {
    resetFields();
    setLoadingSlackChannels(true);
    const results = await slackService.getPublicChannels.execute(input);
    if (isNull(results) || isNull(results.getSlackChannelsList.channels)) {
      throw new Error('Invalid response');
    }
    if (results.getSlackChannelsList.error) {
      openSnackbar(results.getSlackChannelsList.error, {
        variant: 'info',
      });
    }

    setChannels(results.getSlackChannelsList);
  } catch (error) {
    logger.error(error);
    openSnackbar(
      `Something went wrong while loading your public slack channels. Please try again later...`,
      {
        variant: 'warning',
      },
    );
  } finally {
    setLoadingSlackChannels(false);
  }
};

export const sendSlackNotification = async (
  blocks: string,
  issueInfo: {
    issueId: string;
    issueName: string;
    appId: string;
    appName: string;
    severity: string;
    policyId: string;
    category: string;
  },
) => {
  try {
    setLoadingSubmit(true);
    const { fields } = snapshot(SlackStore);
    const results = await slackService.sendSlackNotification.execute({
      channel: fields.selectedChannel,
      blocks,
      issueInfo,
      text: fields.userComment,
    });

    if (isNull(results) || isNull(results.sendSlackNotification)) {
      throw new Error('Invalid response');
    }

    if (results.sendSlackNotification.error) {
      openSnackbar(results.sendSlackNotification.error, {
        variant: 'info',
      });
    }
    const { sentSuccessfully } = results.sendSlackNotification;
    if (sentSuccessfully) {
      openSnackbar('Sent successfully!', {
        variant: 'success',
      });
      return results.sendSlackNotification;
    }
  } catch (error) {
    logger.error(error);
    openSnackbar(
      `Opss! somthing went wrong, but no worry we are on it. Please try again later ...`,
      {
        variant: 'warning',
      },
    );
    return false;
  } finally {
    setLoadingSubmit(false);
  }
};
